import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class ProjectsList {
    constructor() {
        this.sections = document.querySelectorAll('.projects-list');
        
        this.ready();
    }
    
    ready() {

        
        this.sections.forEach(sections => {
            
            const categoryFilters = document.querySelectorAll('.category-filter')
            categoryFilters.forEach(filter => {
                filter.addEventListener('change', () => {
                    console.log(filter.value)
                    if(filter.value > 0) {
                        sections.querySelectorAll('.project-list-category').forEach(categorie => {
                            categorie.classList.add('noShow')
                        })
                        sections.querySelector('#category-list-'+filter.value).classList.remove('noShow')
                    } else {
                        sections.querySelectorAll('.project-list-category').forEach(categorie => {
                            categorie.classList.remove('noShow')
                        })
                    }
                })
            })


            const allSliders = sections.querySelectorAll('.swiper')
            allSliders.forEach((slider, index) => {
                slider.classList.add('swiper--category-list-'+index)
                const swiper = new Swiper(slider, {
                    modules: [Navigation, Pagination],
                    grabCursor: true,
                    slidesPerView: 3,
                    spaceBetween: 0,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: slider.querySelector('.slider-button-next--projects-list'),
                        prevEl: slider.querySelector('.slider-button-prev--projects-list'),
                    },
                    pagination: {
                        el: slider.querySelector('.swiper-pagination-nav--projects-list'),
                        type: 'fraction',
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 15,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        },
                    },
                });
            })
        })


        // document.querySelectorAll('.swiper--category-list').forEach((slider, index) => {
        //     console.log(slider)
        // })

    }
}

if (document.querySelector('.projects-list')) {
    new ProjectsList();
}
